import React from 'react';
import { useAuth } from '../../context/AuthContext';
import {
  FiGrid,
  FiBook,
  FiUsers,
  FiRefreshCw,
  FiDollarSign,
  FiBarChart2,
  FiSettings,
  FiChevronLeft,
  FiChevronRight,
  FiBookOpen,
  FiBell,
  FiLayers,
} from 'react-icons/fi';
import './Sidebar.css';

const NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: <FiGrid />, path: 'dashboard' },
  { key: 'books', label: 'Books', icon: <FiBook />, path: 'books' },
  { key: 'members', label: 'Members', icon: <FiUsers />, path: 'members' },
  { key: 'issue-return', label: 'Issue / Return', icon: <FiRefreshCw />, path: 'issue-return' },
  { key: 'collection', label: 'Collections', icon: <FiDollarSign />, path: 'collection' },
  { key: 'reports', label: 'Reports', icon: <FiBarChart2 />, path: 'reports' },
  { key: 'notices', label: 'Notices', icon: <FiBell />, path: 'notices' },
  { key: 'question-papers', label: 'Question Papers', icon: <FiLayers />, path: 'question-papers' },
  { key: 'blogs', label: 'Blogs', icon: <FiBookOpen />, path: 'blogs' },
  { key: 'users', label: 'Users', icon: <FiUsers />, path: 'users', adminOnly: true },
  { key: 'settings', label: 'Settings', icon: <FiSettings />, path: 'settings' },
];

const Sidebar = ({ activePage, onNavigate, collapsed, onToggle }) => {
  const { user } = useAuth();
  return (
    <aside className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''}`}>
      {/* ── Logo ── */}
      <div className="sidebar__logo">
        <div className="sidebar__logo-icon"><FiBook /></div>
        {!collapsed && (
          <div className="sidebar__logo-text">
            <span className="sidebar__logo-name">Dr. SS Johl Library</span>
            <span className="sidebar__logo-tagline">Management System</span>
          </div>
        )}
      </div>

      {/* ── Nav ── */}
      <nav className="sidebar__nav" aria-label="Main navigation">
        {!collapsed && <p className="sidebar__section-label">MAIN MENU</p>}
        <ul className="sidebar__menu">
          {NAV_ITEMS.filter(item => !item.adminOnly || user?.role === 'Admin').map((item) => {
            const isActive = activePage === item.key;
            return (
              <li key={item.key}>
                <button
                  className={`sidebar__item ${isActive ? 'sidebar__item--active' : ''}`}
                  onClick={() => {
                    onNavigate?.(item.key);
                    if (window.innerWidth < 1024 && !collapsed) {
                      onToggle();
                    }
                  }}
                  title={collapsed ? item.label : undefined}
                >
                  <span className="sidebar__item-icon">{item.icon}</span>
                  {!collapsed && <span className="sidebar__item-label">{item.label}</span>}
                  {!collapsed && isActive && <span className="sidebar__active-bar" aria-hidden="true" />}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* ── Collapse Toggle ── */}
      <div className="sidebar__footer">
        {!collapsed && user && (
          <div className="sidebar__user-card">
            <div className="sidebar__user-avatar">{user.name?.charAt(0) || user.username?.charAt(0)}</div>
            <div className="sidebar__user-info">
              <p className="sidebar__user-name">{user.name || user.username}</p>
              <p className="sidebar__user-role">{user.role || 'Staff'}</p>
            </div>
          </div>
        )}
        <button className="sidebar__collapse-btn" onClick={onToggle}>
          {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
